<template>
	<div>
		<div class="relative">
			<div
				v-if="isLabelShow"
				class="user-profile-dadata-input-label"
			>
				{{ context.attributes['label-text'] }}
			</div>
			<div
				:class="`formulate-input-element formulate-input-element--${context.class} w-100 relative`"
				:data-type="context.type"
			>
				<div class="custom-formulate-select-search--input">
					<input
						v-model="model"
						type="text"
						v-bind="context.attributes"
						autocomplete="no"
						@keydown.enter.prevent="selectItem(selection)"
						@keydown.down.prevent="increment"
						@keydown.up.prevent="decrement"
						@click="isOpen = true"
						@blur.prevent="blurHandler"
						@input="search"
					>
					<FormulateInput
						v-if="context.attributes['input-name-selected-text']"
						v-model="model"
						type="hidden"
						:name="context.attributes['input-name-selected-text']"
					/>
				</div>
				<ul
					v-if="isOpen"
					class="formulate-input-dropdown"
				>
					<li
						v-if="filteredOptions.length === 0"
						@mouseleave="handleMouseLeave"
					>
						Совпадений не найдено
					</li>
					<div v-else>
						<li
							v-for="(option, index) in filteredOptions"
							:key="option.id"
							:class="`${selectedIndex === index
								|| selectionIndex === index ? 'dropdown-selected' : ''}`"
							@mouseenter="handleMouseEnter(index)"
							@mouseleave="handleMouseLeave"
							@click.prevent="selectItem(selection)"
							v-text="option.name"
						/>
					</div>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		context: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			selectionIndex: 0,
			selectedIndex: 0,
			textModel: '',
			isOpen: false,
			isHoveredDropdown: false,
		};
	},
	computed: {
		model: {
			get() {
				return this.textModel;
			},
			set(value) {
				this.textModel = value;
			},
		},
		selection() {
			if (this.isOpen && (this.selectionIndex || this.selectionIndex === 0) && this.filteredOptions[this.selectionIndex]) {
				return this.filteredOptions[this.selectionIndex];
			}
			return false;
		},
		filteredOptions() {
			return this.context.options;
		},
		isLabelShow() {
			if (this.context.attributes.is_label_hide) return false;
			return true;
		},
	},
	created() {
		const selectedItem = this.filteredOptions.find((el) => el.id == this.context.model);
		this.selectedIndex = this.filteredOptions.findIndex((el) => el.id == this.context.model);
		this.model = selectedItem?.name || '';

		if (this.selectedIndex !== 0) {
			this.selectionIndex = this.selectedIndex;
		}
	},
	methods: {
		increment() {
			const { length } = this.filteredOptions;
			if (this.selectionIndex + 1 < length) {
				this.selectionIndex++;
			} else {
				this.selectionIndex = 0;
			}
		},
		decrement() {
			const { length } = this.filteredOptions;
			if (this.selectionIndex - 1 >= 0) {
				this.selectionIndex--;
			} else {
				this.selectionIndex = length - 1;
			}
		},
		selectItem(selection) {
			this.selectedIndex = this.selectionIndex;
			this.context.model = selection.id;
			this.model = selection.name;
			this.isOpen = false;
		},
		blurHandler() {
			if (!this.isHoveredDropdown) {
				this.isOpen = false;
			}
		},
		handleMouseEnter(index) {
			this.selectionIndex = index;
			this.isHoveredDropdown = true;
		},
		handleMouseLeave() {
			this.selectionIndex = this.selectedIndex;
			this.isHoveredDropdown = false;
		},
		search(event) {
			this.context.model = null;
			this.context.rootEmit('search', event.target.value);
		},
	},
};
</script>

<style scoped lang="scss">
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.user-profile-dadata-input-label {
    font-weight: 500;
    line-height: 1.2;
	margin-bottom: 0.5rem;
}

// .formulate-input[data-classification='text'] input {
//     border: none !important;
// }
.custom-control {
    min-height: 1.2rem;
}

.custom-formulate-select-search--input {
    display: flex;
    flex-direction: row;
    align-items: center;
    // border: 1px solid #949ABA !important;
}

ul.formulate-input-dropdown  {
    position: absolute;
    z-index: 999;
    width: 100%;
    padding-left: 0;
    list-style-type: none;
	max-height: 400px;
	overflow-y: scroll;
    background-color: white;

    .dropdown-selected {
        background-color: $blue;
        color: #fff;
    }

    li {
        cursor: pointer;
        padding: 0.3rem 0;
        padding-left: 1rem;

        &:hover {
            background-color: $blue;
            color: #fff;
        }
    }

}
// .user-profile-field .formulate-input-wrapper .vs__selected input,
// .user-profile-field .formulate-input-wrapper .formulate-input-element input {
//     padding-left: 0 !important;
// }
</style>
